/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object, func } from 'prop-types';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { trackEvent as track } from '../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import processCss from '../../../../helpers/contentstack/generateValidCss';
import openInNewTab from '../../../../helpers/contentstack/openInNewTab';
import Panel2 from '../../Panel';
import OutageMessage from '../../../GraphqlComponents/CustomerService/Partials/OutageMessage/OutageMessage';
import { getFeatureFlags } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const styles = (theme) => ({
    root: {
        boxSizing: 'border-box',
        display: 'block',
        height: 'auto',
        width: '100%',
        margin: theme?.palette?.genericBanner?.margin,
        textDecoration: 'none',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        color: theme.palette.common.black, // TODO: Font color should come from CMS
        cursor: 'default',
    },
    headline: {
        margin: `0 auto ${theme.spacing(3)}px auto`,
        padding: '10x 20px',
        textAlign: 'center',
        fontSize: '34px',
        color: theme.palette.common.black, // TODO: Font color should come from CMS
    },
    ctaLink: {
        textDecoration: 'none',
    },
    cta: {
        boxSizing: 'border-box',
        display: 'block',
        margin: '0 auto',
        fontSize: '18px',
        fontWeight: '800',
        borderRadius: '2px',
    },
    contentSection: {
        margin: '0 auto',
        textAlign: 'center',
    },
    float: {
        marginLeft: '0px',
    },
});

const GenericBanner = ({
    classes, data, trackEvent, featureFlags,
}) => {
    const banner = data?.reference?.[0];
    const panel = banner?.reference?.[0];
    const panelData = {
        message_collection: panel.message_collection,
        overlays: panel.overlays,
    };
    if (!banner || !panel) {
        return null;
    }

    const unit = banner.dimensions?.unit === 'Percent' ? '%' : 'px';

    const useNewDimensionsIfAvailable = () => {
        /* @intention: To ease the transition of updates made to the CMS
         *             content-type. New fields were added to handle
         *             descrete values and in order to preserve existing
         *             entries (and eliminate broken presentation), the
         *             old fields were "hidden" but the vaules will remain.
         * @return: {obj} - new field values || old field values.
         */
        const obj = {
            width: `${banner.dimensions?.width}${unit}`,
            height: `${banner.dimensions?.height}${unit}`,
            margin: '0 auto',
        };
        if (banner.dimensions?.width_x) {
            obj.width = banner.dimensions.width_x;
        }
        if (banner.dimensions?.height_y) {
            obj.height = banner.dimensions.height_y;
        }
        if (banner.dimensions?.max_width) {
            obj.maxWidth = banner.dimensions?.max_width;
        }
        return obj;
    };

    const bannerStyle = useNewDimensionsIfAvailable();
    bannerStyle.backgroundImage = panel.image?.url ? `url(${panel.image.url})` : '';

    return (

        <Link
            onClick={(e) => {
                e.preventDefault();
                trackEvent({
                    eventCategory: panel.linking?.tracking_event_category || '',
                    eventAction: panel.linking?.tracking_event_action || '',
                    eventLabel: panel.linking?.tracking_event_label || '',
                    eventName: 'feature_interaction', // Requird for GA4 feature_click
                });
            }}
            to={{ pathname: panel.linking?.link?.href }}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {... openInNewTab(panel.linking?.link?.href)}
            title={panel.linking?.link?.title}
            style={bannerStyle}
            className={classes.root}
        >
            <div className={classes.contentSection} style={processCss(panel.container_attributes, true)}>
                {featureFlags['is-atlas-maintenance-alert-enabled'] && (
                    <OutageMessage />
                )}
                <Panel2 className={classes.headline} data={panelData} styleData={panel.message_styling} />
            </div>
        </Link>
    );
};

GenericBanner.propTypes = {
    data: object.isRequired,
    classes: object.isRequired,
    trackEvent: func.isRequired,
    featureFlags: object.isRequired,
};

const mapStateToProps = (state) => ({
    featureFlags: getFeatureFlags(state),
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: bindActionCreators(track, dispatch),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withStyles(styles)(GenericBanner));
